









































import VuePdfApp from 'vue-pdf-app';
import 'vue-pdf-app/dist/icons/main.css';

import { Component, Emit, Prop } from 'vue-property-decorator';
import Modal from '../Modal.vue';
import Super from '@/Super';

@Component({
  components: {
    Modal,
    VuePdfApp
  }
})
export default class PDFModal extends Super {
  @Prop() visible!: boolean;
  @Prop() title!: string;
  @Prop() url!: string;

  @Emit()
  close() {}
}
